import { Injectable, WritableSignal, signal } from '@angular/core';
import { PassageRequest } from '../models/agrinio';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private newRequests: WritableSignal<PassageRequest[]> = signal([]);
  private unreadCount: WritableSignal<number> = signal(0);

  addRequest(request: PassageRequest) {
    const existingRequests = this.newRequests();
    const isNewRequest = !existingRequests.some(r => r.id === request.id);
    if (isNewRequest) {
      this.newRequests.set([...existingRequests, request]);
      this.unreadCount.set(this.unreadCount() + 1);
    }
  }

  getRequests() {
    return this.newRequests();
  }

  getUnreadCount() {
    return this.unreadCount();
  }

  markAllAsRead() {
    this.unreadCount.set(0);
  }
}